const countryData = [
  { name: "Afghanistan", code: "AF", countryCode: "+93" },
  { name: "Albania", code: "AL", countryCode: "+355" },
  { name: "Algeria", code: "DZ", countryCode: "+213" },
  { name: "Andorra", code: "AD", countryCode: "+376" },
  { name: "Angola", code: "AO", countryCode: "+244" },
  { name: "Antigua and Barbuda", code: "AG", countryCode: "+1" },
  { name: "Argentina", code: "AR", countryCode: "+54" },
  { name: "Armenia", code: "AM", countryCode: "+374" },
  { name: "Australia", code: "AU", countryCode: "+61" },
  { name: "Austria", code: "AT", countryCode: "+43" },
  { name: "Azerbaijan", code: "AZ", countryCode: "+994" },
  { name: "Bahamas", code: "BS", countryCode: "+1" },
  { name: "Bahrain", code: "BH", countryCode: "+973" },
  { name: "Bangladesh", code: "BD", countryCode: "+880" },
  { name: "Barbados", code: "BB", countryCode: "+1" },
  { name: "Belarus", code: "BY", countryCode: "+375" },
  { name: "Belgium", code: "BE", countryCode: "+32" },
  { name: "Belize", code: "BZ", countryCode: "+501" },
  { name: "Benin", code: "BJ", countryCode: "+229" },
  { name: "Bhutan", code: "BT", countryCode: "+975" },
  { name: "Bolivia", code: "BO", countryCode: "+591" },
  { name: "Bosnia and Herzegovina", code: "BA", countryCode: "+387" },
  { name: "Botswana", code: "BW", countryCode: "+267" },
  { name: "Brazil", code: "BR", countryCode: "+55" },
  { name: "Brunei", code: "BN", countryCode: "+673" },
  { name: "Bulgaria", code: "BG", countryCode: "+359" },
  { name: "Burkina Faso", code: "BF", countryCode: "+226" },
  { name: "Burundi", code: "BI", countryCode: "+257" },
  { name: "Cabo Verde", code: "CV", countryCode: "+238" },
  { name: "Cambodia", code: "KH", countryCode: "+855" },
  { name: "Cameroon", code: "CM", countryCode: "+237" },
  { name: "Canada", code: "CA", countryCode: "+1" },
  { name: "Central African Republic", code: "CF", countryCode: "+236" },
  { name: "Chad", code: "TD", countryCode: "+235" },
  { name: "Chile", code: "CL", countryCode: "+56" },
  { name: "China", code: "CN", countryCode: "+86" },
  { name: "Colombia", code: "CO", countryCode: "+57" },
  { name: "Comoros", code: "KM", countryCode: "+269" },
  { name: "Congo", code: "CG", countryCode: "+242" },
  { name: "Costa Rica", code: "CR", countryCode: "+506" },
  { name: "Croatia", code: "HR", countryCode: "+385" },
  { name: "Cuba", code: "CU", countryCode: "+53" },
  { name: "Cyprus", code: "CY", countryCode: "+357" },
  { name: "Czech Republic", code: "CZ", countryCode: "+420" },
  { name: "Denmark", code: "DK", countryCode: "+45" },
  { name: "Djibouti", code: "DJ", countryCode: "+253" },
  { name: "Dominica", code: "DM", countryCode: "+1" },
  { name: "Dominican Republic", code: "DO", countryCode: "+1" },
  { name: "Ecuador", code: "EC", countryCode: "+593" },
  { name: "Egypt", code: "EG", countryCode: "+20" },
  { name: "El Salvador", code: "SV", countryCode: "+503" },
  { name: "Equatorial Guinea", code: "GQ", countryCode: "+240" },
  { name: "Eritrea", code: "ER", countryCode: "+291" },
  { name: "Estonia", code: "EE", countryCode: "+372" },
  { name: "Eswatini", code: "SZ", countryCode: "+268" },
  { name: "Ethiopia", code: "ET", countryCode: "+251" },
  { name: "Fiji", code: "FJ", countryCode: "+679" },
  { name: "Finland", code: "FI", countryCode: "+358" },
  { name: "France", code: "FR", countryCode: "+33" },
  { name: "Gabon", code: "GA", countryCode: "+241" },
  { name: "Gambia", code: "GM", countryCode: "+220" },
  { name: "Georgia", code: "GE", countryCode: "+995" },
  { name: "Germany", code: "DE", countryCode: "+49" },
  { name: "Ghana", code: "GH", countryCode: "+233" },
  { name: "Greece", code: "GR", countryCode: "+30" },
  { name: "Grenada", code: "GD", countryCode: "+1" },
  { name: "Guatemala", code: "GT", countryCode: "+502" },
  { name: "Guinea", code: "GN", countryCode: "+224" },
  { name: "Guinea-Bissau", code: "GW", countryCode: "+245" },
  { name: "Guyana", code: "GY", countryCode: "+592" },
  { name: "Haiti", code: "HT", countryCode: "+509" },
  { name: "Honduras", code: "HN", countryCode: "+504" },
  { name: "Hong Kong", code: "HK", countryCode: "+852" },
  { name: "Hungary", code: "HU", countryCode: "+36" },
  { name: "Iceland", code: "IS", countryCode: "+354" },
  { name: "India", code: "IN", countryCode: "+91" },
  { name: "Indonesia", code: "ID", countryCode: "+62" },
  { name: "Iran", code: "IR", countryCode: "+98" },
  { name: "Iraq", code: "IQ", countryCode: "+964" },
  { name: "Ireland", code: "IE", countryCode: "+353" },
  { name: "Italy", code: "IT", countryCode: "+39" },
  { name: "Jamaica", code: "JM", countryCode: "+1" },
  { name: "Japan", code: "JP", countryCode: "+81" },
  { name: "Jordan", code: "JO", countryCode: "+962" },
  { name: "Kazakhstan", code: "KZ", countryCode: "+7" },
  { name: "Kenya", code: "KE", countryCode: "+254" },
  { name: "Kiribati", code: "KI", countryCode: "+686" },
  { name: "Korea, North", code: "KP", countryCode: "+850" },
  { name: "Korea, South", code: "KR", countryCode: "+82" },
  { name: "Kosovo", code: "XK", countryCode: "+383" },
  { name: "Kuwait", code: "KW", countryCode: "+965" },
  { name: "Kyrgyzstan", code: "KG", countryCode: "+996" },
  { name: "Laos", code: "LA", countryCode: "+856" },
  { name: "Latvia", code: "LV", countryCode: "+371" },
  { name: "Lebanon", code: "LB", countryCode: "+961" },
  { name: "Lesotho", code: "LS", countryCode: "+266" },
  { name: "Liberia", code: "LR", countryCode: "+231" },
  { name: "Libya", code: "LY", countryCode: "+218" },
  { name: "Liechtenstein", code: "LI", countryCode: "+423" },
  { name: "Lithuania", code: "LT", countryCode: "+370" },
  { name: "Luxembourg", code: "LU", countryCode: "+352" },
  { name: "Madagascar", code: "MG", countryCode: "+261" },
  { name: "Malawi", code: "MW", countryCode: "+265" },
  { name: "Malaysia", code: "MY", countryCode: "+60" },
  { name: "Maldives", code: "MV", countryCode: "+960" },
  { name: "Mali", code: "ML", countryCode: "+223" },
  { name: "Malta", code: "MT", countryCode: "+356" },
  { name: "Marshall Islands", code: "MH", countryCode: "+692" },
  { name: "Mauritania", code: "MR", countryCode: "+222" },
  { name: "Mauritius", code: "MU", countryCode: "+230" },
  { name: "Mexico", code: "MX", countryCode: "+52" },
  { name: "Micronesia", code: "FM", countryCode: "+691" },
  { name: "Moldova", code: "MD", countryCode: "+373" },
  { name: "Monaco", code: "MC", countryCode: "+377" },
  { name: "Mongolia", code: "MN", countryCode: "+976" },
  { name: "Montenegro", code: "ME", countryCode: "+382" },
  { name: "Morocco", code: "MA", countryCode: "+212" },
  { name: "Mozambique", code: "MZ", countryCode: "+258" },
  { name: "Myanmar", code: "MM", countryCode: "+95" },
  { name: "Namibia", code: "NA", countryCode: "+264" },
  { name: "Nauru", code: "NR", countryCode: "+674" },
  { name: "Nepal", code: "NP", countryCode: "+977" },
  { name: "Netherlands", code: "NL", countryCode: "+31" },
  { name: "New Zealand", code: "NZ", countryCode: "+64" },
  { name: "Nicaragua", code: "NI", countryCode: "+505" },
  { name: "Niger", code: "NE", countryCode: "+227" },
  { name: "Nigeria", code: "NG", countryCode: "+234" },
  { name: "North Macedonia", code: "MK", countryCode: "+389" },
  { name: "Norway", code: "NO", countryCode: "+47" },
  { name: "Oman", code: "OM", countryCode: "+968" },
  { name: "Pakistan", code: "PK", countryCode: "+92" },
  { name: "Palau", code: "PW", countryCode: "+680" },
  { name: "Palestine", code: "PS", countryCode: "+970" },
  { name: "Panama", code: "PA", countryCode: "+507" },
  { name: "Papua New Guinea", code: "PG", countryCode: "+675" },
  { name: "Paraguay", code: "PY", countryCode: "+595" },
  { name: "Peru", code: "PE", countryCode: "+51" },
  { name: "Philippines", code: "PH", countryCode: "+63" },
  { name: "Poland", code: "PL", countryCode: "+48" },
  { name: "Portugal", code: "PT", countryCode: "+351" },
  { name: "Qatar", code: "QA", countryCode: "+974" },
  { name: "Romania", code: "RO", countryCode: "+40" },
  { name: "Russia", code: "RU", countryCode: "+7" },
  { name: "Rwanda", code: "RW", countryCode: "+250" },
  { name: "Saint Kitts and Nevis", code: "KN", countryCode: "+1" },
  { name: "Saint Lucia", code: "LC", countryCode: "+1" },
  { name: "Saint Vincent and the Grenadines", code: "VC", countryCode: "+1" },
  { name: "Samoa", code: "WS", countryCode: "+685" },
  { name: "San Marino", code: "SM", countryCode: "+378" },
  { name: "Sao Tome and Principe", code: "ST", countryCode: "+239" },
  { name: "Saudi Arabia", code: "SA", countryCode: "+966" },
  { name: "Senegal", code: "SN", countryCode: "+221" },
  { name: "Serbia", code: "RS", countryCode: "+381" },
  { name: "Seychelles", code: "SC", countryCode: "+248" },
  { name: "Sierra Leone", code: "SL", countryCode: "+232" },
  { name: "Singapore", code: "SG", countryCode: "+65" },
  { name: "Slovakia", code: "SK", countryCode: "+421" },
  { name: "Slovenia", code: "SI", countryCode: "+386" },
  { name: "Solomon Islands", code: "SB", countryCode: "+677" },
  { name: "Somalia", code: "SO", countryCode: "+252" },
  { name: "South Africa", code: "ZA", countryCode: "+27" },
  { name: "South Sudan", code: "SS", countryCode: "+211" },
  { name: "Spain", code: "ES", countryCode: "+34" },
  { name: "Sri Lanka", code: "LK", countryCode: "+94" },
  { name: "Sudan", code: "SD", countryCode: "+249" },
  { name: "Suriname", code: "SR", countryCode: "+597" },
  { name: "Sweden", code: "SE", countryCode: "+46" },
  { name: "Switzerland", code: "CH", countryCode: "+41" },
  { name: "Syria", code: "SY", countryCode: "+963" },
  { name: "Taiwan", code: "TW", countryCode: "+886" },
  { name: "Tajikistan", code: "TJ", countryCode: "+992" },
  { name: "Tanzania", code: "TZ", countryCode: "+255" },
  { name: "Thailand", code: "TH", countryCode: "+66" },
  { name: "Timor-Leste", code: "TL", countryCode: "+670" },
  { name: "Togo", code: "TG", countryCode: "+228" },
  { name: "Tonga", code: "TO", countryCode: "+676" },
  { name: "Trinidad and Tobago", code: "TT", countryCode: "+1" },
  { name: "Tunisia", code: "TN", countryCode: "+216" },
  { name: "Turkey", code: "TR", countryCode: "+90" },
  { name: "Turkmenistan", code: "TM", countryCode: "+993" },
  { name: "Tuvalu", code: "TV", countryCode: "+688" },
  { name: "Uganda", code: "UG", countryCode: "+256" },
  { name: "Ukraine", code: "UA", countryCode: "+380" },
  { name: "United Arab Emirates", code: "AE", countryCode: "+971" },
  { name: "United Kingdom", code: "GB", countryCode: "+44" },
  { name: "United States", code: "US", countryCode: "+1" },
  { name: "Uruguay", code: "UY", countryCode: "+598" },
  { name: "Uzbekistan", code: "UZ", countryCode: "+998" },
  { name: "Vanuatu", code: "VU", countryCode: "+678" },
  { name: "Vatican City", code: "VA", countryCode: "+379" },
  { name: "Venezuela", code: "VE", countryCode: "+58" },
  { name: "Vietnam", code: "VN", countryCode: "+84" },
  { name: "Yemen", code: "YE", countryCode: "+967" },
  { name: "Zambia", code: "ZM", countryCode: "+260" },
  { name: "Zimbabwe", code: "ZW", countryCode: "+263" },
];

export const countries = countryData.map(c => ({ name: c.name, code: c.code, countryCode: c.countryCode }));

export const getPopularCountries = () => {
  const popularCodes = ['NP', 'IN', 'US', 'GB', 'AU', 'CA', 'DE', 'SG', 'AE', 'CN'];
  return popularCodes.map(code => countryData.find(c => c.code === code)).filter(Boolean);
};

export const searchCountries = (query) => {
  if (!query || query.trim() === '') {
    return [...countryData].sort((a, b) => a.name.localeCompare(b.name));
  }
  const term = query.toLowerCase().trim();
  return countryData
    .filter(c => c.name.toLowerCase().includes(term) || c.code.toLowerCase() === term)
    .sort((a, b) => a.name.localeCompare(b.name));
};
